import PropTypes from 'prop-types';
import React from 'react';

export default class OnsiteNotificationsScrollable extends React.Component {
    constructor(props) {
        super(props);

        this.innerHeight = 'auto';
        this.scrollableNode = null;
        this.handleWheel = this.handleWheel.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.viewportHeightDiff !== this.props.viewportHeightDiff) {
            this.setInnerHeight(nextProps.viewportHeightDiff);
        }
    }

    handleWheel(e) {
        const node = this.scrollableNode;
        const scrollHeight = node.scrollHeight;
        const scrollTop = node.scrollTop;
        const clientHeight = node.clientHeight;
        const isDeltaPositive = e.deltaY > 0;

        if (
            this.isScrollingPreventable(scrollHeight, clientHeight)
            && (this.isScrollingAtTop(isDeltaPositive, scrollTop)
                || this.isScrollingAtBottom(isDeltaPositive, scrollTop, scrollHeight, clientHeight))
        ) {
            e.preventDefault();
        }
    }

    isScrollingPreventable(scrollHeight, clientHeight) {
        // allow scrollable prevention when scrollable panel is large enough to have internal scrolling
        return scrollHeight > clientHeight;
    }

    isScrollingAtTop(isDeltaPositive, scrollTop) {
        return !isDeltaPositive && scrollTop === 0;
    }

    isScrollingAtBottom(isDeltaPositive, scrollTop, scrollHeight, clientHeight) {
        return isDeltaPositive && scrollTop >= (scrollHeight - clientHeight);
    }

    setInnerHeight(viewportHeightDiff) {
        const height = this.scrollableNode.offsetHeight + viewportHeightDiff;
        this.innerHeight = height > 0 ? height : 'auto';
    }

    getStyles() {
        return {
            height: this.innerHeight,
        };
    }

    render() {
        return (
            <div className="onsite-notifications__content-scroll" >
                <div
                    ref={node => this.scrollableNode = node}
                    onWheel={this.handleWheel}
                    className="onsite-notifications__content-scroll__inner"
                    style={this.getStyles()}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

OnsiteNotificationsScrollable.propTypes = {
    children: PropTypes.node.isRequired,
    viewportHeightDiff: PropTypes.number,
};



// WEBPACK FOOTER //
// ./node_modules/@99designs/globalnav/src/components/onsite-notifications-scrollable.jsx